/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
const Transactionhistory = () => {
    const [user, setUser] = useState();
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;
    const [limit, setLimit] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [numberOfPages, setNumberOfPages] = useState(0);
    const [searchList, setSearchList] = useState("");
    const [searchType, setSearchType] = useState("0");
    const [findByStatus, setFindByStatus] = useState("0");
    const [checkingId, setCheckingId] = useState(null);
    const setpageLimit = (event) => setLimit(event.target.value);
    const searchHandler = (event) => setSearchList(event.target.value);
    const searchByStatus = (event) => setFindByStatus(event.target.value);
    const handlePageClick = (data) => {
        setPageNumber(data.selected + 1);
    };
    const profle = () => {
        const access_token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${access_token}` };
        axios.get(`${baseUrl}txn/deposit/all?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}`, { headers })
            .then((res) => {
                setUser(res.data.admin);
                setNumberOfPages(res.data.totalPages);
            })
            .catch((err) => console.log(err));
    };
    // Updated Swal theme to match Light/Purple UI
    const editAmountOnly = (id, currentAmount, currentStatus) => {
        Swal.fire({
            title: 'Edit Deposit Amount',
            text: `Enter new amount below:`,
            input: 'number',
            inputValue: currentAmount,
            showCancelButton: true,
            confirmButtonText: 'Update Now',
            confirmButtonColor: '#57155a', // Purple
            cancelButtonColor: '#6c757d',
            background: '#fff',
            color: '#333',
            inputValidator: (value) => {
                if (!value || value <= 0) return 'Valid amount required!';
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const finalAmount = Number(result.value);
                const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };
                axios.post(`${baseUrl}userdipositupdate/${id}`,
                    {
                        amount: finalAmount,
                        status: currentStatus || "Pending"
                    },
                    { headers }
                )
                    .then(() => {
                        profle();
                        Swal.fire({
                            title: 'Updated!',
                            text: `Amount updated to ₹${finalAmount}`,
                            icon: 'success',
                            timer: 1500,
                            showConfirmButton: false,
                            background: '#fff',
                            color: '#333'
                        });
                    })
                    .catch((err) => {
                        console.error("Update Error:", err);
                        Swal.fire({ title: 'Error', text: 'Update failed!', icon: 'error' });
                    });
            }
        });
    };
    const withdrowPass = (id, currentAmount) => {
        Swal.fire({
            title: 'Approve Deposit?',
            html: `Confirm approving <b>₹${currentAmount}</b> as SUCCESS?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#27ae60', // Green
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Approve It!',
            background: '#fff',
            color: '#333',
        }).then((result) => {
            if (result.isConfirmed) {
                const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };
                axios.post(`${baseUrl}userdipositupdate/${id}`, { status: "SUCCESS" }, { headers })
                    .then(() => {
                        profle();
                        Swal.fire({ title: 'Approved!', icon: 'success', background: '#fff', color: '#333', timer: 1500, showConfirmButton: false });
                    })
                    .catch((e) => {
                        Swal.fire({ icon: 'error', title: 'Error', text: 'Approval failed!', background: '#fff', color: '#333' });
                    });
            }
        });
    };
    const withdrowFail = (id) => {
        Swal.fire({
            title: 'Reject Deposit?',
            text: "Mark this transaction as FAILED?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, Reject it!',
            background: '#fff',
            color: '#333'
        }).then((result) => {
            if (result.isConfirmed) {
                const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };
                axios.post(`${baseUrl}userdipositupdate/${id}`, { status: "FAILED" }, { headers })
                    .then(() => {
                        profle();
                        Swal.fire({ title: 'Rejected', icon: 'info', background: '#fff', color: '#333', timer: 1500, showConfirmButton: false });
                    });
            }
        });
    };
    const recheckDeposit = (id) => {
        const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };
        setCheckingId(id);
        axios.post(`${baseUrl}admin/deposit/recheck/${id}`, {}, { headers })
            .then((res) => {
                profle();
                const status = res.data?.status;
                Swal.fire({
                    title: status === "pending" ? "Still Pending" : "Rechecked",
                    text: res.data?.message || "Gateway status updated",
                    icon: status === "pending" ? "info" : "success",
                    timer: 1800,
                    showConfirmButton: false,
                    background: '#fff',
                    color: '#333'
                });
            })
            .catch((err) => {
                const message = err.response?.data?.message || "Gateway recheck failed!";
                Swal.fire({ title: 'Error', text: message, icon: 'error', background: '#fff', color: '#333' });
            })
            .finally(() => setCheckingId(null));
    };
    const canRecheckGateway = (data) => {
        return String(data.payment_gatway || "").toLowerCase() === "upigateway" && data.order_token;
    };
    const dateFormat = (e) => new Date(e).toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' });
    useEffect(() => { profle(); }, [pageNumber, limit, searchList, searchType, findByStatus]);
    if (!user) return null;
    // Premium Styles
    const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
    
    .admin-mgmt-page { background: #f0f2f5; min-height: 100vh; padding: 20px; font-family: 'Poppins', sans-serif; }
    
    .modern-card { background: #fff !important; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); overflow: hidden; margin-top: 20px; }
    .card-header-custom { background: linear-gradient(45deg, #57155a, #8e44ad); padding: 20px; }
    .card-title-custom { margin: 0; color: white !important; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; font-size: 1.1rem; }
    
    /* Filters */
    .filters-bar { display: flex; gap: 10px; flex-wrap: wrap; padding: 20px; background: #fafafa; border-bottom: 1px solid #eee; align-items: center; }
    .form-control-custom { border: 1px solid #ddd; border-radius: 8px; padding: 10px 15px; outline: none; font-size: 0.9rem; flex: 1; min-width: 140px; color: #333 !important; background: white; }
    .form-control-custom:focus { border-color: #57155a; box-shadow: 0 0 0 2px rgba(87, 21, 90, 0.1); }
    
    /* Table */
    .table-responsive { overflow-x: auto; padding: 0 20px 20px 20px; }
    .custom-table { width: 100%; border-collapse: collapse; min-width: 1000px; }
    .custom-table thead th { background: #f8f9fa !important; color: #636e72 !important; font-weight: 700; text-transform: uppercase; font-size: 0.8rem; padding: 15px 20px; text-align: left; border-bottom: 2px solid #eee; }
    .custom-table tbody td { padding: 12px 20px; border-bottom: 1px solid #f1f1f1; vertical-align: middle; color: #2d3436 !important; font-size: 0.9rem; }
    .custom-table tbody tr:hover { background: #fafafa !important; }
    
    /* Status Badges */
    .status-badge { padding: 5px 10px; border-radius: 6px; font-size: 0.75rem; font-weight: 700; text-transform: uppercase; display: inline-block; }
    .st-success { background: #e8f5e9; color: #2e7d32; }
    .st-pending { background: #fff8e1; color: #f57f17; }
    .st-failed { background: #ffebee; color: #c62828; }
    
    /* Action Buttons */
    .btn-action { border: none; padding: 6px 12px; border-radius: 6px; font-weight: 600; font-size: 0.75rem; cursor: pointer; transition: 0.2s; margin-right: 5px; }
    .btn-pass { background: #e8f5e9; color: #2e7d32; }
    .btn-pass:hover { background: #c8e6c9; }
    .btn-fail { background: #ffebee; color: #c62828; }
    .btn-fail:hover { background: #ffcdd2; }
    .btn-recheck { background: #e3f2fd; color: #1565c0; }
    .btn-recheck:hover { background: #bbdefb; }
    .btn-action:disabled { opacity: 0.65; cursor: not-allowed; }
    .btn-link-user { color: #57155a; text-decoration: none; font-weight: 600; background: #f3e5f5; padding: 4px 8px; border-radius: 4px; font-size: 0.8rem; }
    
    /* Special Elements */
    .amount-box { font-weight: 700; color: #57155a; display: flex; align-items: center; gap: 8px; }
    .edit-icon { color: #ccc; cursor: pointer; transition: 0.2s; }
    .edit-icon:hover { color: #57155a; }
    .ss-img { width: 40px; height: 40px; border-radius: 6px; object-fit: cover; cursor: pointer; border: 1px solid #eee; transition: 0.2s; }
    .ss-img:hover { transform: scale(1.1); border-color: #57155a; }
    
    /* Pagination */
    .pagination { display: flex; list-style: none; padding: 0; justify-content: center; gap: 5px; margin-top: 20px; flex-wrap: wrap; }
    .page-item { display: inline-block; }
    .page-link { padding: 8px 14px; border-radius: 8px; border: 1px solid #eee; color: #666 !important; cursor: pointer; text-decoration: none; font-size: 0.9rem; font-weight: 500; display: block; background: white; transition: 0.2s; }
    .page-link:hover { background: #f9f9f9; color: #57155a !important; border-color: #ddd; }
    .active .page-link { background: #57155a; color: white !important; border-color: #57155a; box-shadow: 0 4px 10px rgba(87, 21, 90, 0.3); }
  `;
    return (
        <div className="admin-mgmt-page">
            <style>{styles}</style>
            <div className="row">
                <div className="col-12">
                    <div className="modern-card">
                        
                        {/* Header */}
                        <div className="card-header-custom">
                            <h4 className="card-title-custom">Deposit History</h4>
                        </div>
                        {/* Filters */}
                        <div className="filters-bar">
                            <select className='form-control-custom' onChange={(e) => setSearchType(e.target.value)}>
                                <option value="0">Search By...</option>
                                <option value="Name">Name</option>
                                <option value="Phone">Phone</option>
                                <option value="_id">Txn ID</option>
                            </select>
                            
                            <input type='text' placeholder='Type to search...' className='form-control-custom' onChange={searchHandler} />
                            
                            <select className='form-control-custom' onChange={searchByStatus}>
                                <option value="0">All Status</option>
                                <option value="FAILED">Failed</option>
                                <option value="Pending">Pending</option>
                                <option value="PAID">Paid / Success</option>
                            </select>
                            <select className='form-control-custom' style={{maxWidth: '100px'}} onChange={setpageLimit}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        {/* Table */}
                        <div className="table-responsive">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>ID</th>
                                        <th>User Details</th>
                                        <th>Order / UTR</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Proof</th>
                                        <th>Action</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {user.map((data, key) => (
                                        <tr key={data._id}>
                                            <td style={{color: '#999', fontWeight: 'bold'}}>{(pageNumber - 1) * limit + (key + 1)}</td>
                                            
                                            <td>
                                                <div style={{fontFamily:'monospace', fontSize:'0.8rem', color:'#666'}}>{data._id.substring(0, 8)}...</div>
                                            </td>
                                            <td>
                                                <div style={{display:'flex', flexDirection:'column', gap:'2px'}}>
                                                    {data.User_id && 
                                                        <Link className="btn-link-user" to={`/user/view_user/${data.User_id._id}`}>
                                                            {data.User_id.Name}
                                                        </Link>
                                                    }
                                                    <span style={{fontSize:'0.75rem', color:'#888'}}>Ph: {data.User_id?.Phone}</span>
                                                </div>
                                            </td>
                                            
                                            <td>
                                                <div style={{fontSize:'0.8rem'}}>
                                                    <div><strong>Ord:</strong> {data.order_token}</div>
                                                    <div style={{color:'#666'}}><strong>UTR:</strong> {data.referenceId || '-'}</div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="amount-box">
                                                    <span>₹{data.amount}</span>
                                                    {(data.status !== 'PAID' && data.status !== 'SUCCESS' && data.status !== 'FAILED') && (
                                                        <i className="mdi mdi-pencil edit-icon" onClick={() => editAmountOnly(data._id, data.amount, data.status)} title="Edit Amount">✏️</i>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <span className={`status-badge ${
                                                    (data.status === 'PAID' || data.status === 'SUCCESS') ? 'st-success' : 
                                                    (data.status === 'FAILED') ? 'st-failed' : 'st-pending'
                                                }`}>
                                                    {data.status}
                                                </span>
                                            </td>
                                            <td>
                                                {data.Transaction_Screenshot ? (
                                                    <img
                                                        src={`${baseUrl}${data.Transaction_Screenshot.replace(/^\/+/, '')}`}
                                                        alt="Proof"
                                                        className="ss-img"
                                                        onClick={() => {
                                                            Swal.fire({
                                                                imageUrl: `${baseUrl}${data.Transaction_Screenshot.replace(/^\/+/, '')}`,
                                                                imageAlt: 'Deposit Proof',
                                                                background: '#fff',
                                                                showCloseButton: true,
                                                                showConfirmButton: true,
                                                                confirmButtonText: 'Close',
                                                                confirmButtonColor: '#333',
                                                                color: '#333',
                                                                width: 'auto'
                                                            });
                                                        }}
                                                    />
                                                ) : <span style={{color:'#ccc'}}>-</span>}
                                            </td>
                                            <td>
                                                {(data.status !== 'PAID' && data.status !== 'SUCCESS') ? (
                                                    <div style={{display:'flex', flexWrap:'wrap', gap:'5px'}}>
                                                        {canRecheckGateway(data) && (
                                                            <button
                                                                className="btn-action btn-recheck"
                                                                onClick={() => recheckDeposit(data._id)}
                                                                disabled={checkingId === data._id}
                                                            >
                                                                {checkingId === data._id ? "Checking..." : "Recheck"}
                                                            </button>
                                                        )}
                                                        {data.status !== 'FAILED' && (
                                                            <>
                                                                <button className="btn-action btn-pass" onClick={() => withdrowPass(data._id, data.amount)}>✓ Approve</button>
                                                                <button className="btn-action btn-fail" onClick={() => withdrowFail(data._id)}>✕ Reject</button>
                                                            </>
                                                        )}
                                                        {data.status === 'FAILED' && !canRecheckGateway(data) && (
                                                            <span style={{color:'#aaa', fontSize:'0.8rem', fontStyle:'italic'}}>Completed</span>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <span style={{color:'#aaa', fontSize:'0.8rem', fontStyle:'italic'}}>Completed</span>
                                                )}
                                            </td>
                                            
                                            <td style={{fontSize:'0.8rem', color:'#888'}}>{dateFormat(data.createdAt)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {/* Pagination */}
                        <div className='p-3'>
                            <ReactPaginate
                                previousLabel={"← Prev"}
                                nextLabel={"Next →"}
                                pageCount={numberOfPages}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                activeClassName={"active"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Transactionhistory;
